import { Fragment, useRef } from "react";
import { SignalsPayload } from "@timeedit/registration-schemas";
import { isDefined } from "@timeedit/registration-shared";
import { Layout } from "@timeedit/ui-components/antd";
import { CourseList } from "./CourseList";
import { GroupPage } from "./GroupPage/GroupPage";
import { RegistrationHeader } from "./RegistrationHeader";
import "./registrationPage.scss";

interface RegistrationDesktopProps {
  signal?: SignalsPayload;
  isHub?: boolean;
}
export function RegistrationDesktop({
  signal,
  isHub,
}: RegistrationDesktopProps): React.JSX.Element {
  const Wrapper = isHub ? Fragment : Layout;
  const focusRef = useRef<HTMLInputElement>(null);
  return (
    <Wrapper>
      {!isHub && isDefined(signal) && <RegistrationHeader signal={signal} />}
      <div className="registration-page__content registration-page__content--desktop">
        <section
          className="registration-page__course-activities"
          aria-labelledby="course-list-header"
        >
          <CourseList focusRef={focusRef} />
        </section>
        <section
          className="registration-page__group-lists"
          aria-labelledby="activity-header"
        >
          <GroupPage focusRef={focusRef} />
        </section>
      </div>
    </Wrapper>
  );
}
